export default "__VITE_ASSET__CsBEfX4C__"